import { type ParkingSpotQueue } from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
import { parkingSpotQueueFilters } from '@/app/settings/modules/market/queues/parkingspot-queues/filters';

export const ParkingSpotQueueItem: RelationFieldProps<ParkingSpotQueue> = {
  filters: parkingSpotQueueFilters,
  renderItem: (item) => ({
    title: item?.name ?? '',
    descriptionItems: <></>,
  }),
};
